import React from "react";
import Back from "../assets/images/logo.png";
import Position from "@assets/images/local.png";
import "./common.less";
import intl from "react-intl-universal"; //多语言
import { connect } from "react-redux";
import Actor from "tools/actor"; //全局接口方法
import {
  getCountryList,
  setCountryActive,
  setTime,
  setShop,
  chooseModel,
  setKey,
  setpc,
  setDeliver,
  setcityshow,
  setcitylists,
  setcityname,
  setThpro,
} from "tools/store";
import { withRouter } from "react-router-dom";
import WebApi from "tools/webApi";
import APPJS from "tools/cc";

//全局状态
const mapStateToProps = (state: any) => {
  return {
    countryList: state.defaultState.countryList,
    countryActive: state.defaultState.countryActive,
    ispc: state.defaultState.ispc,
    cityshow: state.defaultState.cityshow,
    citylists: state.defaultState.citylists,
    cityname: state.defaultState.cityname,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  getCountryList: (v: any) => {
    dispatch(getCountryList(v));
  },
  setCountryActive: (v: any) => {
    dispatch(setCountryActive(v));
  },
  chooseModel: (v: any) => {
    dispatch(chooseModel(v));
  },
  setShop: (v: any) => {
    dispatch(setShop(v));
  },
  setTime: (v: any) => {
    dispatch(setTime(v));
  },
  setKey: (v: any) => {
    dispatch(setKey(v));
  },
  setpc: (v: any) => {
    dispatch(setpc(v));
  },
  setDeliver: (v: any) => {
    dispatch(setDeliver(v));
  },
  setcityshow: (v: any) => {
    dispatch(setcityshow(v));
  },
  setcitylists: (v: any) => {
    dispatch(setcitylists(v));
  },
  setcityname: (v: any) => {
    dispatch(setcityname(v));
  },
  setThpro: (v: any) => {
    dispatch(setThpro(v));
  },
});
@(connect(mapStateToProps, mapDispatchToProps) as any)
class Title extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      //国家列表
      countryShow: false,
      searchcountry: '',//搜索国家    
    };
  }
  //url解析入参
  _parseQueryString = (queryString: any) => {
    if (queryString && queryString.startsWith("?")) {
      const result: any = {};
      queryString
        .slice(1)
        .split("&")
        .forEach((item: any) => {
          const keyValueList = item.split("=");
          result[keyValueList[0]] = decodeURIComponent(keyValueList[1]);
        });
      return result;
    } else {
      return {};
    }
  };
  //官网处理方式
  pcdo = async (v?: string) => {
    if (this.props.countryActive.name) {
      return;
    }
    let _this = this;
    let country: string =
      v ||
      this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.country ||
      "";
    let res: any;
    if (this.props.countryList.length < 1) {
      console.log(this.props.countryList);
      res = await WebApi.getCountries({});
    } else {
      res = {
        code: 200,
        data: this.props.countryList,
      };
    }
    console.log(res);
    // let res: any = await WebApi.getCountries({});
    let arr: any = [];
    if (res && res.code === 200) {
      let a = res.data || [];
      for (let v of a) {
        if (v.name.toLowerCase() === country.toLowerCase()) {
          arr.push(v);
          console.log(arr);
          // 寄修区域
          if (v.mcc === '510') {
            // console.log("印尼")
            // this.citylist(v.name);
            if (//免费券
              this._parseQueryString("?" + window.location.href.split("?")[1])
                ?.comefrom === "orderlotteryfree"
            ) {

            } else {
              this.citylist(v.name);
            }
          } else if (v.mcc === '404000') {
            // alert("链接选择印度")
            if (//2. 清洗券
              this._parseQueryString("?" + window.location.href.split("?")[1])
                ?.comefrom === "orderlotteryfree"
            ) { } else {
              this.citylist(v.name);
            }
          } else if (v.mcc === '520') {
            // console.log("泰国")
            this.props.setDeliver({ type: 1, data: true });
            this.props.setcityname({});
          } else if (v.mcc === '515') {
            // console.log("菲律宾")
            this.props.setDeliver({ type: 1, data: true });
            this.props.setcityname({});
          } else {
            this.props.setDeliver({ type: 1, data: false });
            this.props.setcityname({});
          }


          _this.props.setCountryActive(arr[0]);

          Actor.getBannerImg(arr[0].mcc);//切换banner
          Actor.getgohomeservice(arr[0].mcc);//是否支持上门维修
          Actor.getgohomeservicelist(arr[0].mcc);//获取上门省份列表

          _this.props.getCountryList(res.data);
          if (window.location.href.indexOf("/shopDetails/") >-1&&window.location.href.indexOf("shopId=") >-1) {

          }else  if (window.location.href.indexOf("/order") < 0) {
            let par: string = window.location.href.split("?")[1]
              ? "?" + window.location.href.split("?")[1]
              : "";
            setTimeout(() => {
              this.props.history.push("/order" + par);
            }, 0);
          }
          return;
        }
      }
      //没有的话自选
      _this.props.getCountryList(res.data);
      _this.setState({
        countryShow: true,
      });
    }
  };

  // 印尼城市选择，印度城市
  citylist = async (vname: string) => {
    // if (this.props.citylists.length > 0) {
    //   this.props.setcityshow(true);
    // } else {
    let res: any = await WebApi.deliveryCity({ country: vname })
    if (res && +res.code === 200) {
      this.props.setcityshow(true);
      let ressetcity = res.data || []
      ressetcity.push({ cityEng: "Others", cityThai: "Lainnya" });
      this.props.setcitylists(ressetcity);
    }
    // }
  }

  //生命周期
  componentDidMount() {
    let _this = this;
    //1.强制跳转https
    // if (
    //   window.location.protocol === "http:" &&
    //   window.location.href.indexOf("service.carlcare.com") > -1
    // ) {
    //   let b = window.location.href.replace("http://", "https://");
    //   window.location.href = b;
    // } else
    if (//2. 清洗券
      this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.comefrom === "orderlotteryfree"
    ) {
      this.props.setpc(true);
      this.pcdo();
      // this.props.setDeliver({ type: 1, data: false });
      // this.props.setcityname({ cityEng: "Others", cityThai: "Lainnya" });
      // this.props.setcityshow(false);
    } else if (//2. 来自官网
      this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.comefrom === "pc" &&
      this._parseQueryString("?" + window.location.href.split("?")[1])?.country
    ) {
      // 2.1 国家是全球单独处理
      if (
        this._parseQueryString(
          "?" + window.location.href.split("?")[1]
        )?.country.toLowerCase() === "global"
      ) {
        if (this.props.countryActive.name) {
          return;
        }
        this.props.setpc(true);
        Actor.getCountries();
        this.setState({
          countryShow: true,
        });
        // 2.2 来自官网指定国家
      } else {
        this.props.setpc(true);
        this.pcdo();
      }
      //3. 来自活动url带国家参数
    } else if (
      this._parseQueryString("?" + window.location.href.split("?")[1])?.country
    ) {
      this.props.setpc(false);
      this.pcdo();
      //4. 无国家参数处理
    } else if (
      this.props.countryList.length < 1 ||
      !this.props.countryActive.name
    ) {
      // 定位兼容app处理
      _this.dolocation();
      // APPJS.userinfo().then((res: any) => {
      //   if ((res.appVersion.slice(1) >= "6.0.4")) {
      //     APPJS.requestLocation().then((res: any) => {
      //       if (res.has) {
      //         _this.getCountry(
      //           res.latitude,//"-6.1753942",
      //           res.longitude,//"106.827183",
      //           "en"
      //         );
      //       } else {
      //         // 4.2 国家手动选择
      //         Actor.getCountries();
      //         _this.setState({
      //           countryShow: true,
      //         });
      //       }
      //     })
      //   } else {
      //     _this.dolocation();
      //   }
      // })
    }
  }
  dolocation = () => {
    let _this = this;
    //4.1可定位处理
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log(position.coords);
        _this.getCountry(
          position.coords.latitude,
          position.coords.longitude,
          "en"
        );
      }, function () {
        // 4.2 国家手动选择
        Actor.getCountries();
        _this.setState({
          countryShow: true,
        });
      });
    } else {
      // 4.2 国家手动选择
      Actor.getCountries();
      this.setState({
        countryShow: true,
      });
    }
  }

  //定位获取国家
  getCountry(lat: any, lng: any, lang: any) {
    let _this = this;
    let mapUrl =
      "https://maps.google.com/maps/api/geocode/json?latlng=" +
      lat +
      "," +
      lng +
      "&language=" +
      lang +
      "&sensor=false&key=AIzaSyDamA_twuZn52mwikfA5HelGSe6QrEp4Pk&callback=tonew&result_type=country";
    window.fetch(mapUrl).then((res) => {
      res.json().then((data) => {
        let v: string = data?.results[0]?.formatted_address + "";
        _this.pcdo(v);
      });
    });
  }
  goBack = () => {
    //window.history.go(-1);
  };
  chooseCountry = () => {
    if (this.props.click) {
      return;
    } else {
      this.setState({
        countryShow: true,
      });
    }
  };
  choosed = (v: any) => {
    console.log(v);
    this.setState({
      countryShow: false,
    });
    if (v.mcc !== this.props.countryActive.mcc || ['404000', '510'].indexOf(v.mcc) > -1) {//兼容印尼
      // 寄修区域
      if (v.mcc === '510') {
        // console.log("印尼")
        this.citylist(v.name);
      } else if (v.mcc === '404000') {
        // alert("主动选择印度")
        this.citylist(v.name);
      } else if (v.mcc === '520') {
        // console.log("泰国")
        this.props.setDeliver({ type: 1, data: true });
        this.props.setcityname({});
      } else if (v.mcc === '515') {
        // console.log("菲律宾")
        this.props.setDeliver({ type: 1, data: true });
        this.props.setcityname({});
      } else {
        this.props.setDeliver({ type: 1, data: false });
        this.props.setcityname({});
      }

      this.props.setCountryActive(v);

      Actor.getBannerImg(v.mcc);//切换banner
      Actor.getgohomeservice(v.mcc);//是否支持上门维修
      Actor.getgohomeservicelist(v.mcc);//获取上门省份列表

      //清空绑定国家的数据
      this.props.chooseModel({
        leftName: "", //品牌
        leftCode: "",
        rightName: "", //机型
        rightCode: "",
      });
      this.props.setShop({
        storeName: "",
        storeCode: "",
        storeAddr: "",
      });
      this.props.setTime([]);
      this.props.setKey("");

      // const lang = intl.getInitOptions().currentLocale;
      // intl.getInitOptions().currentLocale = lang === "zh" ? "en" : "zh";
      // if (v.mcc === "98532145500000000") {
      //   document.body.style.direction = "rtl";
      // } else {
      //   document.body.style.direction = "ltr";
      // }
      // this.forceUpdate();
      let par: string = window.location.href.split("?")[1]
        ? "?" + window.location.href.split("?")[1]
        : "";
      this.props.history.push("/order" + par);
    }
  };

  // 印尼城市选择
  choosedcity = (i: any) => {
    console.log(i)
    this.props.setcityname(i);
    this.props.setcityshow(false);
    if (i.cityEng.toLocaleLowerCase() !== "others") {
      this.props.setDeliver({ type: 1, data: true });
      // 判断官网快速匹配
      if (this.props.ispc && this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.needDelivery === "1") {
        console.log("官网快速匹配")
        let _this = this;
        setTimeout(() => {
          _this.props.handle();
        }, 300);

      }

      // 印度寄修处理
      if (this.props.countryActive.mcc === '404000') {
        this.props.setThpro(i);
      }
    } else {
      this.props.setDeliver({ type: 1, data: false });
    }
  }

  match = (e: any) => {
    this.setState({
      searchcountry: e.currentTarget.value
    })
  }
  render() {
    return this.props.ispc ? (
      <div className="notitle">
        <div
          className={
            this.state.countryShow ? "select_country" : "select_country disnone"
          }
        >
          <div className="cover"></div>
          <div className="countries">
            <div>
              <h3>{intl.get("title.name1")}</h3>
              <div className='input'>
                <input type="text" placeholder='Enter country and search' onChange={this.match.bind(this)} value={this.state.searchcountry} />
              </div>
            </div>
            <ul>
              {this.props.countryList.map((v: any, i: number) => {
                return (
                  <li
                    key={i}
                    onClick={this.choosed.bind(this, v)}
                    className={
                      // v.mcc === this.props.countryActive.mcc ? "active" : ""
                      v.mcc === this.props.countryActive.mcc ? (v.name.toLowerCase().indexOf(this.state.searchcountry.toLowerCase()) > -1 ? "active" : "active disnone") : (
                        v.name.toLowerCase().indexOf(this.state.searchcountry.toLowerCase()) > -1 ? "" : "disnone"
                      )
                    }
                  >
                    {v.name}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* 印尼城市选择 */}
        {this.props.cityshow ?
          <div
            className={"select_country"}>
            <div className="cover"></div>
            <div className="countries">
              <div>
                <h3>{intl.get("add1.name00") || intl.get("add1.name2")}</h3>
              </div>
              <ul>
                {this.props.citylists.map((v: any, i: number) => {
                  return (
                    <li key={i} className={v.cityEng === this.props.cityname.cityEng ? "active" : ''} onClick={this.choosedcity.bind(this, v)} >
                      {this.props.countryActive.mcc === 520 ? (v.cityThai || v.cityEng) : (v.cityEng || v.cityThai)}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div> : ""}
      </div>
    ) : (
      <div className="title">
        <div className="left">
          <img src={Back} alt="" className="backImg" onClick={this.goBack} />
          <span>{this.props.content}</span>
        </div>
        {this.props.show ? (
          <div className="right" onClick={this.chooseCountry}>
            <img src={Position} alt="" />
            <span>{this.props.countryActive.name}</span>
          </div>
        ) : (
          ""
        )}
        <div
          className={
            this.state.countryShow ? "select_country" : "select_country disnone"
          }
        >
          <div className="cover"></div>
          <div className="countries">
            <div>
              <h3>{intl.get("title.name1")}</h3>
              <div className='input'>
                <input type="text" placeholder='Enter country and search' onChange={this.match.bind(this)} value={this.state.searchcountry} />
              </div>
            </div>
            <ul>
              {this.props.countryList.map((v: any, i: number) => {
                return (
                  <li
                    key={i}
                    onClick={this.choosed.bind(this, v)}
                    className={
                      v.mcc === this.props.countryActive.mcc ? (v.name.toLowerCase().indexOf(this.state.searchcountry.toLowerCase()) > -1 ? "active" : "active disnone") : (
                        v.name.toLowerCase().indexOf(this.state.searchcountry.toLowerCase()) > -1 ? "" : "disnone"
                      )
                    }
                  >
                    {v.name}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* 印尼城市选择 */}
        {this.props.cityshow ?
          <div
            className={"select_country"}>
            <div className="cover"></div>
            <div className="countries">
              <div>
                <h3>{intl.get("add1.name00") || intl.get("add1.name2")}</h3>
              </div>
              <ul>
                {this.props.citylists.map((v: any, i: number) => {
                  return (
                    <li key={i} className={v.cityEng === this.props.cityname.cityEng ? "active" : ''} onClick={this.choosedcity.bind(this, v)} >
                      {this.props.countryActive.mcc === 520 ? (v.cityThai || v.cityEng) : (v.cityEng || v.cityThai)}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div> : ""}
      </div>
    );
  }
}

export default withRouter(Title);
